import { ReactNode, UIEventHandler, useEffect, useRef, useState } from "react";
import { CalendarBaseSetting } from "../../firestore/Types/UI/CalendarSetting";
import { days, times } from "../../Utils/TimeSlotUtils";
import moment from "moment";

export function CalendarBase({ classNameCss = "", mainLayer, secondaryLayer, gutterLayer, setWeeek, calendarSetting, week }: { classNameCss?:string,mainLayer: () => ReactNode, secondaryLayer: () => ReactNode,gutterLayer: () => ReactNode, setWeeek?: React.Dispatch<React.SetStateAction<number>>, calendarSetting?: CalendarBaseSetting, week: number }) {
    const [gridColsClass, setGridColsClass] = useState("");
    const headerRef = useRef<HTMLDivElement>(null);
    const lowerRef = useRef<HTMLDivElement>(null);
    const scrollRef = useRef<HTMLDivElement>(null);
    const dates = [] as number[];

    if (!week) {
        week = 0;
    }
    if (gridColsClass === "") {
        setGridColsClass("sample");
    }
    const getDayOverlay = (day: string) => {
        return (
            <div className="grid grid-rows-48">
                {
                    Array.from({ length: 48 }, (_, sindex) => {
                        if (day === "Monday" && sindex === 28) {
                            return (<div className="calendar-gap-lines" key={sindex} ref={scrollRef}></div>);
                        }
                        return (<div className="calendar-gap-lines" key={sindex}></div>);
                    })
                }
            </div>
        )
    }
    function getCurrentWeekDates() {
        const currentDate = moment().add(week, "weeks");
        const firstDayOfWeek = currentDate.startOf("isoWeek"); // Assuming week starts on Monday
        

        for (let i = 0; i < 7; i++) {
            dates.push(firstDayOfWeek.clone().add(i, "day").date());
        }

    }
    getCurrentWeekDates();

    function getCurrentMonthAndYear() {
        const currentDate = new Date();
        return (currentDate.toLocaleString('default', { month: 'long' })) + " " + currentDate.getFullYear(); 
    }

    const handleNextWeek = () => {
        if (week >= 4) {
            return;
        }
        if (setWeeek) {
            setWeeek(week + 1);
        }
    }

    const handlePreviousWeek = () => {
        if (week <= 0) {
            return;
        }
        if (setWeeek) {
            setWeeek(week - 1);
        }
    }
    
    const getDayHeader = (day: string, index: number) => {
        if (calendarSetting && calendarSetting.showDate === true) {
            return (<div className="cal-header text-center">{day.slice(0, 3)} - { dates[index]} </div>);
        } else {
            return (<div className="cal-header text-center">{day.slice(0, 3)}</div>);
        }
    }
    
    const showTopGutter = () => {
        if (calendarSetting && calendarSetting.showTopGutter === true) {
            return (
            <div className="flex flex-row p-1 border border-b-1 border-l-0 border-t-0 border-r-0 mb-3">
                <div className="cal-header text-center">{getCurrentMonthAndYear()}</div>
                <div className="grow relative">
                    <div className="absolute-0">  {gutterLayer()}</div>

                </div>
                    <div className="cal-header text-center w-6">{week > 0 && <div className="back-button-sm" onClick={handlePreviousWeek}></div>}</div>
                    <div className="cal-header text-center w-6">{week < 4 && <div className="forward-button-sm" onClick={handleNextWeek}></div>}</div>
            </div>
            );
        } else {
            return (<></>)
        }
    }

    useEffect(() => {
        setTimeout(() => {
            if (scrollRef.current) {
                scrollRef.current.scrollIntoView();
            }
        }, 0);
    }, []);

    const handleScroll: UIEventHandler<HTMLDivElement> = () => {
        if (headerRef.current && lowerRef.current) {
            headerRef.current.scrollLeft = lowerRef.current.scrollLeft;
        }
    }

    return (
        <div className={"section-box p-2 grow flex flex-col " + classNameCss} >
            {showTopGutter()}
            <div ref={headerRef} className="flex flex-row border border-r-0 border-l-0 border-t-0 calendar-days-shadow pt-1 min-h-[30px] overflow-hidden">
                <div className="time-header-column relative"></div>
                <div className="grow grid grid-cols-7days">
                    {days.map((day, index) => (
                        <div key={index}>
                            {getDayHeader(day,index)}
                        </div>
                    ))}
                </div>
            </div>

            <div ref={lowerRef} className="overflow-scroll grow" onScroll={handleScroll}>
                <div className="flex flex-row">
                    <div className="time-header-column relative">

                        <div className="time-header-leading">

                        </div>
                        {times.map((time, index) => (
                            <div key={index}>
                                <div className="time-header-times">
                                    <div className="time-header-text">
                                        {time}
                                    </div>
                                </div>
                            </div>))
                        }
                    </div>
                    <div className="relative grow">
                        <div className="absolute inset-0">
                            <div className="grow grid grid-cols-7days">
                                {days.map((day, index) => (
                                    <div key={index}>
                                        <div className="calendar-leading" >

                                        </div>
                                        {getDayOverlay(day)}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="absolute inset-0">
                            <div className="grow grid grid-cols-7days">
                                {secondaryLayer()}
                            </div>
                        </div>
                        <div className="absolute inset-0">
                            <div className="grow grid grid-cols-7days">
                                {mainLayer()}
                            </div>
                        </div>
                    </div>
                </div>
                

            </div>

        </div>
    );
}